// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"842":"99d771e894c9810c75d6","989":"2e56721be5e5f3a7aedd"}[chunkId] + ".js";
};